<script lang="ts">
      import Globus from '$lib/components/ui/Globus.svelte'
      import { onDestroy, onMount, tick } from 'svelte'
      import type { MenuItem } from '../Menu'
      import MenuArrow from '../MenuPlus.svelte'
      import { getHeaderVisiblityContext } from '$lib/ui/menu/index.svelte'
      import { flipAnimation } from '$lib/utils/flip'
      import MenuInlineItem from './MenuInlineItem.svelte'
      import MenuInlineSubmenu from './MenuInlineSubmenu.svelte'
      import LocaleSwitcher from '$lib/components/locale/LocaleSwitcher.svelte'

      const ui = getHeaderVisiblityContext()

      async function handleClick(e: Event) {
            //e.stopPropagation()
      }

      let { items = [] as MenuItem[], class: className = '' } = $props()

</script>

<div class="{className} absolute top-0 right-0 bg-transparent z-50 mr-2 md:mr-6 flex gap-6 text-xl transition-all ease-in-out duration-700">
      {#each items as item, i (i)}
            {#if item.type == 'link'}
                  <MenuInlineItem {item} class="opacity-65 hover:opacity-100" onclick={handleClick}></MenuInlineItem>
            {:else if item.type == 'internal'}
                  <MenuInlineItem {item} class="opacity-65 hover:opacity-100" onclick={handleClick}></MenuInlineItem>
            {:else if item.type == 'menu'}
                  <MenuInlineSubmenu {item} onclick={handleClick}></MenuInlineSubmenu>
            {/if}
      {/each}

      <div class="flex items-center relative justify-center opacity-65 hover:opacity-100">
        <div class="absolute w-full h-[70%] mt-[-.4rem] border-[1px] border-black rounded-full "></div>
        <LocaleSwitcher class="px-3 py-0"></LocaleSwitcher>
      </div>
</div>
